import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Styles from './EditForm.module.scss';
export function SourceEditor(props) {
    const textAreaRef = React.useRef(null);
    const sourceRef = React.useRef(null);
    function keyPress(event) {
        const textArea = event.target;
        if (!textArea) {
            return false;
        }
        function insert(text) {
            const start = textArea.selectionStart;
            const end = textArea.selectionEnd;
            textArea.value =
                textArea.value.substring(0, start) + text + textArea.value.substring(end);
            textArea.selectionStart = textArea.selectionEnd = start + text.length;
            props.setSource(textArea.value);
        }
        if (event.key === 'Enter') {
            const textLines = textArea.value.substring(0, textArea.selectionStart).split('\n');
            const currentLine = textLines[textLines.length - 1];
            const begin = '\n' + currentLine.replace(currentLine.trimStart(), '');
            insert(begin);
            event.preventDefault();
            return true;
        }
        if (event.key === 'Tab') {
            insert('    ');
            event.preventDefault();
            return true;
        }
    }
    function handleScroll(event) {
        if (textAreaRef?.current && sourceRef?.current) {
            sourceRef.current.scrollTop = textAreaRef.current.scrollTop;
            sourceRef.current.scrollLeft = textAreaRef.current.scrollLeft;
        }
    }
    //TODO handle scroll in read only mode
    return (_jsxs("div", { className: Styles.source_editor + (!props.allowEdit ? ' ' + Styles.readonly : ''), children: [props.allowEdit && (_jsx("textarea", { onChange: event => props.setSource(event.target.value), onKeyDown: keyPress, onScroll: handleScroll, value: props.source ?? '', wrap: "hard", "aria-label": "source", ref: textAreaRef })), _jsx("pre", { ref: sourceRef, children: _jsx("code", { children: renderSourceEditor(props.source ?? '') }) })] }));
}
function renderSourceEditor(source) {
    const parts = split(source);
    const result = [];
    const defaultColor = '#D4D4C8';
    const signColor = '#808080';
    const elementColor = '#569CD6';
    const attributeNameColor = '#9CDCFD';
    const attributeValueColor = '#CE9178';
    let color = 'white';
    let isProperty = false;
    let inElement = false;
    let key = 0;
    for (const token of parts) {
        let tokenHandled = false;
        if (!isProperty && token === '"') {
            isProperty = true;
            color = attributeValueColor;
            tokenHandled = true;
        }
        if (token === '<' || token === '>' || token === '?' || token === '/') {
            color = signColor;
        }
        if (token === ' ') {
            if (inElement) {
                color = attributeNameColor;
            }
            else {
                color = defaultColor;
            }
        }
        result.push(_jsx("span", { style: { color: color }, children: token }, key));
        key++;
        if (tokenHandled) {
            continue;
        }
        if (token === '<') {
            color = elementColor;
            inElement = true;
        }
        if (isProperty && token === '"') {
            isProperty = false;
            color = defaultColor;
        }
        if (token === '>') {
            color = defaultColor;
            inElement = false;
        }
        if (token === '?' || token === '/') {
            color = elementColor;
        }
    }
    return result;
}
function split(source) {
    const result = [];
    let current = '';
    const splitChars = ['<', '>', '"', '=', ' ', '?', '/'];
    for (let i = 0; i < source.length; i++) {
        const char = source.charAt(i);
        if (splitChars.indexOf(char) >= 0) {
            result.push(current);
            current = '';
            result.push(char);
            continue;
        }
        current += char;
    }
    return result;
}
